import { Cell, Row } from '../../../../ui/DataGrid/DataGrid';
import Skeleton from '../../../../ui/Skeleton/Skeleton';
import SkeletonText from '../../../../ui/SkeletonText/SkeletonText';
import css from './ProductTableSkeleton.css';

const ROW_COUNT = 6;

const ProductTableSkeleton = () => {
  return (
    <>
      {Array.from({ length: ROW_COUNT }, (_: unknown, index: number) => (
        <Row id={`product-table-skeleton-${index}`} isDisabled key={index}>
          <Cell>
            <Skeleton className={css.itemNo} />
          </Cell>
          <Cell>
            <Skeleton className={css.image} />
          </Cell>
          <Cell />
          <Cell>
            <span className={css.nameCellInner}>
              <Skeleton className={css.name} />
              <Skeleton className={css.modelsCount} />
            </span>
          </Cell>
          <Cell>
            <SkeletonText className={css.price} lineCount={2} />
          </Cell>
          <Cell />
        </Row>
      ))}
    </>
  );
};

export default ProductTableSkeleton;
